interface Part {
	pos: [number, number];
	title: string;
	subtitle: string;
	text: string;
	trailer: string;
	full: string[];
	code: string;
}

export default {
	"schwarze-marit": {
		pos: [740, 540],
		title: "Die Schwarze Marit",
		subtitle: "Nordufer der Hallig – U. Voehl und J. Kleudgen",
		text: `Ein tragisches Schicksal scheint die schwermütige
		Halligmalerin ereilt zu haben, und ein Rätsel umgibt
		ihr letztes Gemälde, das eine wunderschöne Frau in
		Schwarz zeigt. Handelt es sich um Selbstbildnis,
		oder existiert die Fremde tatsächlich, die
		möglicherweise am Tod der Malerin schuld
		ist? Jahrzehnte später bemüht sich ein junger
		Mann, der durch eine Erbschaft in den Besitz
		des Bildes gelangt, um Aufklärung.`,
		trailer: "Die schwarze Marit Trailer",
		full: ["Die schwarze Marit"],
		code: "9XAkz67OnzNT",
	},
	"schnee-auf-seeigel": {
		pos: [2460, 704],
		title: "Schnee, der auf Seeigel fällt",
		subtitle: "Backenswarft – U. Voehl",
		text: `Als sich Maik Glaubitz kurz vor
		Weihnachten auf den Weg zur Hallig Hooge
		macht, um seinen alten Freund Jürg wiederzusehen,
		ahnt er nicht, was ihn erwartet. Die Zimmerwirtin
		Swaantje auf der Backenswarft hält einen Brief für ihn
		bereit, in dem er um einen merkwürdigen Gefallen gebeten
		wird.`,
		trailer: "Schnee der auf Seeigel fällt Trailer",
		full: ["Schnee der auf Seeigel fällt"],
		code: "Ach53n8Wbw4g",
	},
	"fliegender-hollaender": {
		pos: [2640, 528],
		title: "Der Fliegende Holländer",
		subtitle: "Blick nach Oland/Langeneß – J. Kleudgen",
		text: `»Was sagen Sie da, ham Sie gesehn?
		Sie ham die Lore fahren geseh’n, vor Tagesanbruch,
		is das richtig?« Mit diesen Worten
		mischt sich Jes Sibbers in das Gespräch dreier
		junger Männer vom Festland ein, von denen
		einer eine merkwürdige Beobachtung gemacht
		hat. Der Fischer erzählt ihnen die Geschichte des
		Holländer-Jan von der Hallig Oland, der aus Raffgier einen
		Menschen tötete. Und bald wird ihnen bewusst, wie schaurig
		ihre Ent deckung wirklich ist.`,
		trailer: "Der fliegende Holländer Trailer",
		full: [
			"Der fliegende Holländer erster Teil",
			"Der fliegende Holländer zweiter Teil",
		],
		code: "Yu7SvXX6eFmj",
	},
	sturmflutmann: {
		pos: [2404, 768],
		title: "Der Sturmflutmann",
		subtitle: "Backenswarft – U. Voehl",
		text: `Als der Sturmflutmann auf die Hallig Hooge
		kommt, sind die Kinder völlig aus dem Häuschen.
		Abend für Abend missachten sie die Verbote ihrer
		Eltern und schleichen zu seinem Zelt, wo er ihnen
		Filme von der großen weiten Welt zeigt und
		ihnen Ruhm und Reichtum verspricht.
		Doch er hegt keine lauteren
		Absichten …`,
		trailer: "Der Sturmflutmann Trailer",
		full: ["Der Sturmflutmann"],
		code: "cPOvOrtX673A",
	},
	"kapitaen-johann-bandix": {
		pos: [632, 840],
		title: "Was Kapitän Johann Bandix …",
		subtitle: "Ehemalige Pohnswarft – J. Kleudgen",
		text: `Er ist der einzige Überlebende der Totenreise
		im Jahre 1777, bei der dreihundert Seeleute starben.
		Doch seitdem Kapitän Johann Bandix auf die Hallig
		Hooge zurückgekehrt ist, wird er von einem seltsamen
		Geheimnis umgeben. Er fürchtet die See und
		das, was daraus aufsteigen mag, und zieht sich immer
		mehr in sein Haus auf der Pohnswarft zurück. Doch
		siebzig Jahre später, am Dreikönigstag, dem Tag, an
		dem sein Schiff einst gesunken war, holt ihn
		seine Vergangenheit ein.`,
		trailer: "bandix-trailer",
		full: ["bandix"],
		code: "t9WdLZjwQJPU",
	},
	"schwarze-fething": {
		pos: [2308, 1508],
		title: "Der schwarze Fething",
		subtitle: "Hanswarft – U. Voehl und J. Kleudgen",
		text: `»Du darfst nicht gehen! Bleib hier! Es sind doch schon
		so viele!« Als ihr geliebter Towe sich den Männern an-
		schließt, die ausziehen, um Schiffsbrüchige eines auf
		Japsand aufgelaufenen Schiffes zu retten, ahnt
		Mette, dass ihr Geliebter nicht zurückkehren wird.
		Da man seine Leiche jedoch nicht finden kann,
		gibt sie die Hoffnung nie auf. Alle wundern
		sich, als es eines Tages heißt, dass die Mette
		schwanger sei, hat sie doch schließlich die anderen Inselburschen
		nie eines Blickes gewürdigt.
		Und dass sie das Kind nach der
		Geburt vor den anderen Bewohnern der Hallig verborgen hält,
		gibt den Gerüchten weitere Nahrung.`,
		trailer: "Der schwarze Fething Trailer",
		full: ["Der schwarze Fething"],
		code: "IYKfy6qGccrt",
	},
	hoellenpesel: {
		pos: [748, 900],
		title: "Der Höllenpesel",
		subtitle: "Ehemalige Pohnswarft – U. Voehl und J. Kleudgen",
		text: `Elke. Elke! Seit Tagen hörte sie die Stimme.
		Der Wind trug sie ihr zu. Die Stimme rief ihren
		Namen. So als wollte sie erlöst werden.
		Manchmal gelang es ihr, sie zu ignorieren,
		doch wenn sie abends in ihrem Bett unter dem
		Dach lag, vernahm sie die Stimme umso lauter
		zwischen dem Rauschen des Windes und dem
		Klappern der Dachziegel. Dann schaute sie
		hinauf zu dem kleinen Kreuz über ihrem Bett
		und betete. Das Kreuz hatte ihre Mutter ihr
		geschenkt. Zwei Wochen bevor ihre Eltern bei
		einem tragischen Unfall ums Leben gekommen waren.

		Doch Elke ist sich nicht sicher, ob das Kreuz
		sie vor der der alten Gundula Pohns beschützen
		kann, die mit ihrer grauen Meerkatze in
		einem windschiefen Haus lebt und ganz
		gewiss eine Hexe ist.`,
		trailer: "Der Höllenpesel Trailer",
		full: ["Der Höllenpesel"],
		code: "0tfUadO6riUb",
	},
	"phantom-im-nebel": {
		pos: [2308, 1236],
		title: "Das Phantom im Nebel",
		subtitle: "Kirchwarft – U. Voehl",
		text: `Meike findet im Schilf eine
		alte Pfeife aus dunklem Brujère -
		holz und will sie sie zuerst wieder
		fortschmeißen, doch ihr Ehemann Sven interessiert
		sich für das Fundstück und beschäftigt sich in den darauffolgenden
		Tagen mit nichts anderem. Als jedoch nachts ein
		unerklärlicher Wind an den Fensterläden rüttelt und ihnen
		tagsüber eine finstere Gestalt folgt, wird ihr bewusst, dass
		sie etwas unternehmen muss, um den Fund wieder loszuwerden.
		Doch beinahe ist es zu spät …`,
		trailer: "Das Phantom im Nebel Trailer",
		full: [
			"Das Phantom im Nebel erster Teil",
			"Das Phantom im Nebel zweiter Teil",
		],
		code: "eDTyuotquBu3",
	},
	"schicksal-santa-lucrezia": {
		pos: [3360, 2044],
		title: "Vom Schicksal der Santa Lucrezia",
		subtitle: "Landsende – J. Kleudgen",
		text: `Eigentlich hätte Ole Roloff es ja besser
		wissen müssen, doch als er sich am Abend des 21. Februars
		nach einem Streit mit seinem Bruder Hein südlich der
		Ockenswarft den Heimweg durchs Watt nach Pellworm
		antritt, scheint ihn der Alkohol leichtsinnig gemacht zu
		haben. Jedenfalls erreicht er sein Ziel nicht, und die fünf
		Freiwilligen, die sie für die Suche nach seiner Leiche melden,
		machen eine schaurige Entdeckung.`,
		trailer: "Vom Schicksal der Santa Lukrezia Trailer",
		full: ["Vom Schicksal der Santa Lukrezia"],
		code: "XOksF8SskVJw",
	},
} as Record<string, Part>;
